import moment from 'moment';

export const DateFormat = 'MM/DD/YYYY';
export const DatePayloadFormat = 'YYYY-MM-DD';
export const DateFormatDisplay = 'MMMM DD, YYYY';
export const DateFormatDisplayShort = 'MMM DD, YYYY';

export const TimeFormat = 'HH:mm';

/**
 * Get date display
 * @param {string|date|moment} value
 * @param {string} languageCode
 */
export const getDateDisplay = (value: string) => {
  return moment(value).format(DateFormat);
};

/**
 * Get date payload display
 * @param {string|date|moment} value
 * @param {string} languageCode
 */
export const getDatePayload = (value: string) => {
  try {
    return moment(value).format(DatePayloadFormat);
  } catch (error) {
    return value;
  }
};

/**
 * Get time display
 * @param {string|date|moment} value
 * @param {string} languageCode
 */
export const getTimeDisplay = (value: string) => {
  return moment(value).format(TimeFormat);
};

/**
 * Get month start day
 */
export const getMonthStartDay = (date?: any) => {
  return date ? moment(date).startOf('month') : moment().startOf('month');
};

/**
 * Get month end day
 */
export const getMonthEndDay = (date?: any) => {
  return date ? moment(date).endOf('month') : moment().endOf('month');
};

/**
 * Get current week
 * @param {string} languageCode
 */
export const getCurrentWeekDay = () => {
  return moment().format('ww');
};

/**
 * Get week start day
 */
export const getWeekStartDay = (date?: any) => {
  return date ? moment(date).startOf('week') : moment().startOf('week');
};
/**
 * Get next week start day
 * @param {date} currentWeekStartDate
 */
export const getPreviousWeekStartDate = date => {
  return moment(date).add(7, 'days');
};

/**
 * Get previous week start day
 * @param {date} currentWeekStartDate
 */
export const getNextWeekStartDate = date => {
  return moment(date).add(-7, 'days');
};
/**
 * Get week start day
 * @param {date} startDate
 */
export const getWeekEndDay = (startDate?: any) => {
  return startDate ? moment(startDate).endOf('week') : moment().endOf('week');
};

/**
 * Check if date is first date of a week
 * @param {date} date
 */
export const isFirstWeekDate = (date?: any) => {
  try {
    const day = moment(date).day();

    return day === 0;
  } catch (error) {
    return false;
  }
};

/**
 * Check if date is last date of a week
 * @param {date} date
 */
export const isLastWeekDate = (date?: any) => {
  try {
    const day = moment(date).day();
    return day === 6;
  } catch (error) {
    return false;
  }
};

export const getInitialDateRange = (isAllTimesheet: boolean) => {
  const weekStartDate = isAllTimesheet ? getMonthStartDay() : getWeekStartDay();
  const weekEndDate = isAllTimesheet ? getMonthEndDay() : getWeekEndDay();
  const dateRange: [Date, Date] = [weekStartDate.startOf('week').toDate(), weekEndDate.endOf('week').toDate()];
  return dateRange;
};
